var file_upload_viewer_default = {
  "fontElementMap": "s8ySe",
  "file_upload_container": "kMXRQ",
  "file_upload_error_container": "oINgK",
  "file_upload_link": "mO22q",
  "width_three": "fidK6",
  "file_upload_text_container": "H56-n",
  "width_two": "WDUUk",
  "file_upload_state": "jR4BA",
  "mobile_status_icon": "O0lYz",
  "file_upload_name_container": "ZRNEh",
  "file_upload_name": "EGumS",
  "file_upload_extension": "ZajDM",
  "width_one": "m7aw7",
  "file_upload_type_icon": "bITK4",
  "file_loader_icon": "nBNNR",
  "spin": "vUPcK",
  "file_upload_type": "JykcX",
  "file_upload_text_error": "SXEb8",
  "file_upload_icon_frame": "u6AG4",
  "file_upload_icon_background": "E87l-"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
